// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_f4-6";
export var emphasizeQuantity = "_f4-3";
export var flatBottomCorners = "_f4-5";
export var productImage = "_f4-0";
export var quantityContainer = "_f4-2";
export var tooltip = "_f4-1";
export var wrapAndEllipsesOverflow = "_f4-4";